import { AccountingCodesAdminEffects } from './accounting-codes-admin.effect';
import { AnalyticsMetadataEffects } from './analytics-metadata.effect';
import { AssortmentEffects } from './assortment.effect';
import { CompanyEffects } from './company.effect';
import { CredentialsEffects } from './credentials.effect';
import { DeliveryAddressEffects } from './delivery-address.effect';
import { DeliveryCountriesEffects } from './delivery-countries.effect';
import { FeedEffects } from './feed.effect';
import { ForgotPasswordEffects } from './forgot-password.effect';
import { ForgotUsernameEffects } from './forgot-username.effect';
import { OnboardingCountriesEffects } from './onboarding-countries.effect';
import { OrderApprovalEffects } from './order-approval.effect';
import { OrderCardsAdminEffects } from './order-cards-admin.effect';
import { OrderCardsEffects } from './order-cards.effect';
import { PriceEffects } from './price.effect';
import { ProfileCountriesEffects } from './profile-countries.effects';
import { PunchOutEffects } from './punch-out.effect';
import { RegisterEffects } from './register.effect';
import { ResetPasswordEffects } from './reset-password.effect';
import { ShipTosEffects } from './ship-tos.effect';
import { ShoppingListEntryEffects } from './shopping-list-entry.effect';
import { ShoppingListEffects } from './shopping-list.effect';
import { SiteFamilyConfigEffects } from './site-family-config.effect';
import { StockInfoEffects } from './stock-info.effect';
import { UserConsentsEffect } from './user-consents.effect';
import { UserDetailsEffects } from './user-details.effect';

export const effects: any[] = [
  AccountingCodesAdminEffects,
  CompanyEffects,
  DeliveryAddressEffects,
  ForgotPasswordEffects,
  ForgotUsernameEffects,
  ResetPasswordEffects,
  UserDetailsEffects,
  RegisterEffects,
  ProfileCountriesEffects,
  DeliveryCountriesEffects,
  CredentialsEffects,
  UserConsentsEffect,
  ShoppingListEffects,
  ShoppingListEntryEffects,
  PunchOutEffects,
  PriceEffects,
  StockInfoEffects,
  OrderApprovalEffects,
  AnalyticsMetadataEffects,
  SiteFamilyConfigEffects,
  OrderCardsEffects,
  OrderCardsAdminEffects,
  FeedEffects,
  ShipTosEffects,
  AssortmentEffects,
  OnboardingCountriesEffects,
];

export * from './accounting-codes-admin.effect';
export * from './analytics-metadata.effect';
export * from './assortment.effect';
export * from './company.effect';
export * from './credentials.effect';
export * from './delivery-address.effect';
export * from './delivery-countries.effect';
export * from './feed.effect';
export * from './forgot-password.effect';
export * from './forgot-username.effect';
export * from './onboarding-countries.effect';
export * from './order-approval.effect';
export * from './order-cards-admin.effect';
export * from './order-cards.effect';
export * from './price.effect';
export * from './profile-countries.effects';
export * from './punch-out.effect';
export * from './register.effect';
export * from './reset-password.effect';
export * from './ship-tos.effect';
export * from './site-family-config.effect';
export * from './stock-info.effect';
export * from './user-consents.effect';
export * from './user-details.effect';
